import { supabase } from '../supabaseClient';

export const packagesService = {

  async getAll() {
    const { data, error } = await supabase
      .from('packages')
      .select('*')
      .order('sort_order');
    if (error) throw error;
    return data;
  },

  async create(pkg) {
    const { data, error } = await supabase
      .from('packages')
      .insert([{ ...pkg, updated_at: new Date().toISOString() }])
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  async update(id, changes) {
    const { data, error } = await supabase
      .from('packages')
      .update({ ...changes, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single();
    if (error) {
      // Common error: RLS blocked — user is not a superadmin
      if (error.code === '42501' || error.message?.includes('policy')) {
        throw new Error('Permission denied — only superadmins can edit packages');
      }
      throw error;
    }
    return data;
  },

  async delete(id) {
    const { error } = await supabase.from('packages').delete().eq('id', id);
    if (error) throw error;
  },
};
